import GroupPyamentLedger from './group_payment_ledger';
import CashbookCategories from './cashbook_categories';
import FeedbackResponses from './feedback_responses';
import CustomerAccounts from "./customer_accounts";
import AnalyticsEvents from "./analytics_events";
import InvoicePayments from "./invoice_payments";
import SaleOrderLine from './sale_order_line';
import RateListLines from './rate_list_lines';
import wishlist_items from './wishlist_items';
import PosOrderLine from "./pos_order_lines";
import GroupCustomer from './group_customer';
import Categories from "./stock_categories";
import Notifications from './notifications';
import Disputes from "./recharge_disputes";
import BusinessCard from "./business_card";
import GroupPayment from './group_payment';
import TrustedList from './trusted_list';
import GuidedTour from './guided_tour';
import Attendance from "./attendance";
import Signatures from './signatures';
import CartItems from "./cart_items";
import PosOrders from "./pos_orders";
import SaleOrder from "./sale_order";
import Inventory from "./inventory";
import RateList from './rate_list';
import Customer from "./customer";
import Business from "./business";
import LastSync from "./lastSync";
import Recharge from "./recharge";
import Contacts from "./contacts";
import wishlist from './wishlist';
import PosTxns from './pos_txns';
import Address from "./address";
import Journal from "./journal";
import Company from './company';
import Payment from "./payment";
import Invoice from "./invoice";
import Orders from "./orders";
import Group from './groups';
import Stock from "./stock";
import InApp from "./inapp";
import Nudge from './nudge';
import Staff from "./staff";
import User from "./user";
import Cart from "./cart";
import Unit from "./unit";
import CashTxn from './cash_txn';


export const dbModels = [
  CashbookCategories,
  GroupPyamentLedger,
  FeedbackResponses,
  CustomerAccounts,
  AnalyticsEvents,
  InvoicePayments,
  wishlist_items,
  GroupCustomer,
  SaleOrderLine,
  RateListLines,
  Notifications,
  GroupPayment,
  BusinessCard,
  PosOrderLine,
  TrustedList,
  GuidedTour,
  Categories,
  Attendance,
  Signatures,
  PosOrders,
  Inventory,
  CartItems,
  SaleOrder,
  Business,
  Customer,
  LastSync,
  wishlist,
  RateList,
  Recharge,
  Contacts,
  Disputes,
  Invoice,
  Payment,
  Journal,
  Address,
  Company,
  PosTxns,
  Orders,
  Nudge,
  Group,
  Stock,
  Staff,
  InApp,
  User,
  Cart,
  Unit,
  CashTxn
];
